<template>
  <div class="circle-single">
    <div
      class="circle-content circle-content--inner-circle circle-content--default circle-base__content--shadow label-view"
    >
      <lazy-img :src="step.image" class="circle-content__img" />

      <div class="label-view__input-wrap">
        <input
          class="label-view__input"
          type="text"
          :placeholder="$t('label.placeholder')"
          :value="getFormData.label"
          @input="setValue($event.target.value)"
        />
      </div>

      <div class="circle-content__title fade-in" v-html="$t(step.title)"></div>
      <div
        class="circle-content__description fade-in"
        v-html="$t(step.description)"
      ></div>
    </div>
  </div>
</template>

<script>
import Circle from '@/class/Circle';
import { Steps } from '@/models/steps';

export default new Circle(Steps.LABEL).comp;
</script>

<style lang="scss">
.label-view {
  overflow: hidden;

  &::before {
    border-color: transparent white white transparent;
    transform: rotate(45deg);
  }
}

.label-view__input-wrap {
  position: absolute;
  width: 80%;
  top: 25%;
  margin: 0 auto;

  &::after {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 20px;
    bottom: 0;
    margin-left: -2px;
    border: 2px solid white;
    border-top: 0;
  }
}

input.label-view__input[type='text'] {
  text-align: center;
  display: block;
  width: 100%;
  margin: auto;
  padding: 0 !important;

  background-color: transparent !important;
  border: 0 !important;
  box-shadow: none;
  line-height: 1.6;
  font-family: $titleFont;
  font-size: 5em;
  font-weight: normal;
  letter-spacing: 1px;

  color: white;

  &::placeholder {
    color: rgba(white, 0.5);
  }

  &:hover,
  &:focus {
    outline: none;
    background-color: rgba(white, 0.1);
  }
}

@media (max-width: 460px) {
  .label-view__input-wrap {
    top: 30%;
  }
}

@media (min-width: 460.89px) {
  input.label-view__input[type='text'] {
    font-size: 7em;
  }

  .label-view__input-wrap {

    &::after {
      margin-left: -4px;
      border-width: 4px;
    }
  }
}

</style>
